import { StyleSheet, Text, View } from 'react-native'
import { toCurrency } from '@linqpal/models/src/helpers/formatter'
import React, { FC } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import { frequency } from '@linqpal/models/src/dictionaries'
import { IDownPaymentDetails } from '@linqpal/models/src/types/routes'
import { DownPaymentMethod } from '@linqpal/models/src/dictionaries/downPayment'
import RootStore from '../../../../../store/RootStore'
import { IconBill, IconRecurrent } from '../../../../../assets/icons'

interface IProps {
  downPayment: IDownPaymentDetails | null
  weeklyPaymentAmount: number
  paymentOption: any
  showCardFee?: boolean
}

export const PaymentPlanDetails: FC<IProps> = ({
  downPayment,
  weeklyPaymentAmount,
  paymentOption,
  showCardFee = false,
}) => {
  const { t } = useTranslation('global')
  const { getCardFee } = RootStore.screensStore?.paymentMethodsStore

  let downPaymentAmount = downPayment?.amount ?? 0

  if (showCardFee) {
    const cardFee =
      downPayment?.paymentMethod === DownPaymentMethod.Card &&
      downPayment.accountId
        ? getCardFee(downPayment.amount, downPayment.accountId)
        : 0

    downPaymentAmount += cardFee
  }

  return (
    <>
      <View style={styles.wrapper}>
        {downPaymentAmount > 0 && (
          <View style={styles.lineWrapper}>
            <IconBill width={16} />
            <Text style={styles.label}>
              <Trans
                t={t}
                i18nKey={
                  showCardFee &&
                  downPayment?.paymentMethod === DownPaymentMethod.Card
                    ? 'PaymentPlanCard.down-payment-amount-with-fee-line'
                    : 'PaymentPlanCard.down-payment-amount-line'
                }
                components={{
                  styled: <Text style={styles.labelAmount} />,
                }}
                values={{
                  paymentAmount: toCurrency(downPaymentAmount),
                }}
              />
            </Text>
          </View>
        )}

        <View style={styles.lineWrapper}>
          <IconRecurrent width={16} />
          <Text style={styles.label}>
            {paymentOption.frequency === frequency.SINGLE ? (
              <Trans
                t={t}
                i18nKey="PaymentPlanCard.one-time-payment-amount-line"
                components={{
                  styled: <Text style={styles.labelAmount} />,
                }}
                values={{
                  paymentAmount: toCurrency(weeklyPaymentAmount),
                  days: paymentOption.days,
                }}
              />
            ) : paymentOption.term === 1 ? (
              <Trans
                t={t}
                i18nKey="PaymentPlanCard.single-payment-amount-line"
                components={{
                  styled: <Text style={styles.labelAmount} />,
                }}
                values={{
                  paymentAmount: toCurrency(weeklyPaymentAmount),
                  days: paymentOption.days,
                }}
              />
            ) : (
              <Trans
                t={t}
                i18nKey="PaymentPlanCard.multiple-payments-amount-line"
                components={{
                  styled: <Text style={styles.labelAmount} />,
                }}
                values={{
                  paymentAmount: toCurrency(weeklyPaymentAmount),
                  term: paymentOption.term,
                }}
              />
            )}
          </Text>
        </View>
      </View>
    </>
  )
}

const styles = StyleSheet.create({
  wrapper: {
    marginLeft: 20,
    marginBottom: 10,
  },
  lineWrapper: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 5,
    marginBottom: 5,
  },
  label: {
    fontFamily: 'Inter, sans-serif',
    fontWeight: '500',
    fontSize: 12,
    lineHeight: 22,
    color: '#001929',
  },
  labelAmount: {
    fontWeight: '700',
  },
})
